import { FormValidationRule } from "../types";

const greaterThan: FormValidationRule = (c, v) => {
    const valid =
        !isNaN(Number(c.isGreater)) && !isNaN(Number(v))
            ? Number(v) > Number(c.isGreater)
            : true;
    return [
        valid,
        c.errorMessage || `This field should be greater than ${c.isGreater}.`
    ];
};

const lessThan: FormValidationRule = (c, v) => {
    const valid =
        !isNaN(Number(c.isLess)) && !isNaN(Number(v))
            ? Number(v) < Number(c.isLess)
            : true;
    return [
        valid,
        c.errorMessage || `This field should be less than ${c.isLess}.`
    ];
};

const greaterOrEqual: FormValidationRule = (c, v) => {
    const gte = c.isGreaterOrEqual || c.rangeMin;
    const valid =
        (gte || gte === 0) && !isNaN(Number(gte)) && !isNaN(Number(v))
            ? Number(v) >= Number(gte)
            : true;
    return [
        valid,
        c.errorMessage ||
            `This field should be greater than or equal to ${gte}.`
    ];
};

const lessOrEqual: FormValidationRule = (c, v) => {
    const euroCurrency = c.cssClass === "show-currency-in-error" ? "€" : "";
    const lte = c.isLessOrEqual || c.rangeMax;
    const valid =
        lte && !isNaN(Number(lte)) && !isNaN(Number(v))
            ? Number(v) <= Number(lte)
            : true;
    return [
        valid,
        c.errorMessage || `This field should be less than or equal to ${euroCurrency}${lte}.`
    ];
};

export { greaterThan, greaterOrEqual, lessThan, lessOrEqual };
